import { getGameByGameId, postNewGame, putGame, getPlayers, postGameLog } from "../connectors/index.js"

export const actions = {
  passHandlerAction: ({ state, commit, dispatch }) => {
    clearInterval(state.timer.autoPass)
    commit("storeSnapshot")

    commit("appendGameString", "P");
    commit("appendCurrentActionSequence", "P");

    if (state.onDirect) {
      commit("increaseOwns", [0, 1])
    }

    commit("increaseCurrentCount")

    if (state.currentCount >= state.numPlayers) {
      commit("increaseNotAnswered")
      commit("closeQuestion")
    } else {
      const index = state.passingSequence[state.currentCount]
      if (state.players[index].emptySeat) {
        dispatch("passHandlerAction")
      }
    }
  },
  correctHandlerAction: ({ state, commit }, { stakeValue }) => {
    clearInterval(state.timer.autoPass)
    commit("storeSnapshot")

    if (state.gameType === 'mimir') {
      commit("appendGameString", "C");
      commit("appendCurrentActionSequence", "C");
    }

    if (state.gameType === 'stakes') {
      const keyMap = { 20: "R", 10: "T", 5: "Y" }
      commit("appendGameString", keyMap[stakeValue]);
      commit("appendCurrentActionSequence", keyMap[stakeValue]);
      commit("increaseScore", stakeValue)
      commit("increaseStakesCorrect", stakeValue)
    }

    commit("increaseCorrect")
    if (state.onDirect) {
      commit("increaseOwns", [1, 1])
    }

    if (state.currentCount > 0) {
      commit("increaseBonusPoints");
      commit("increaseBonusAttempts");
    } else if (!state.freeDirect) {
      commit("increaseBonusAttempts");
    }

    commit("closeQuestion")
  },

  killHandlerAction({ state, commit }) {
    clearInterval(state.timer.autoPass)
    commit("storeSnapshot")

    commit("appendGameString", "K");
    commit("appendCurrentActionSequence", "K");

    if (state.onDirect) {
      commit("increaseOwns", [0, 1])
    }
    commit("closeQuestion")
    commit("incrementQuestion")
    if (state.currentQuestionNo >= state.questionsList.length) {
      commit("finishGame");
    }
    commit("switchQuestionMode", "Answer")
  },

  wrongHandlerAction: ({ state, commit, dispatch }, { stakeValue }) => {
    clearInterval(state.timer.autoPass)
    commit("storeSnapshot")

    if (state.gameType === "mimir") {
      commit("appendGameString", "W");
      commit("appendCurrentActionSequence", "W");
    }

    if (state.gameType === 'stakes') {
      const keyMap = { 20: "F", 10: "G", 5: "H" }
      commit("appendGameString", keyMap[stakeValue]);
      commit("appendCurrentActionSequence", keyMap[stakeValue]);
      if (stakeValue !== 5 || state.currentCount > 0) {
        commit("decreaseScore", stakeValue)
      }
      commit("increaseStakesWrong", stakeValue)
    }

    if (state.onDirect) {
      commit("increaseOwns", [0, 1])
    }

    if (state.gameType === 'mimir' && (state.currentCount > 0 || !state.freeDirect)) {
      commit("increaseBonusAttempts")
    }

    commit("increaseCurrentCount")

    if (state.currentCount >= state.numPlayers) {
      commit("increaseNotAnswered")
      commit("closeQuestion");
    } else {
      const index = state.passingSequence[state.currentCount]
      if (state.players[index].emptySeat) {
        dispatch("passHandlerAction")
      }
    }
  },

  undoHandlerAction: ({ commit }) => {
    commit("restoreSnapshot")
    commit("startTimer")
  },

  showAnswerHandlerAction: ({ state, commit, getters }) => {
    commit("incrementQuestion")
    if (state.currentQuestionNo >= state.questionsList.length) {
      commit("finishGame");
    }

    if (state.current.question === 1) { //Save game only when players' directs are over.
      putGame(getters.getPostMessageBody, state.objectId)
    }

    commit("switchQuestionMode", 'Answer')
  },

  saveCurrentGameStatus: ({ state, getters }) => {
    putGame(getters.getPostMessageBody, state.objectId)
  },

  updateScoreTable: ({ commit }, { value, pId, property }) => {
    if (Number.isInteger(parseInt(value))) {
      commit("updateScoreTable", { value: parseInt(value), pId, property })
    }
  },
  startTimer: ({ commit, state, dispatch }) => {
    commit("startTimer")
    if (state.onDirect && state.players[state.passingSequence[0]].emptySeat) {
      const autoPass = setInterval(() => {
        if (state.timer.displayTime <= state.timer.directTime - state.timer.passOnEmptyTime) {
          clearInterval(state.timer.autoPass);
          dispatch("passHandlerAction")
        }
      }, 1000)
      commit("setAutoPass", autoPass)
    }
  },

  resetTimer: ({ commit }) => {
    commit("resetTimer")
  },

  incrementTime: ({ commit }) => {
    commit("incrementTime")
  },

  decrementTime: ({ commit }) => {
    commit("decrementTime")
  },

  setGameId: ({ commit }, gameId) => {
    commit("setGameId", gameId)
  },

  setGameType: ({ commit }, gameType) => {
    commit("setGameType", gameType)
  },

  setFileName: ({ commit }, fileName) => {
    commit("setFileName", fileName)
  },

  setPlayerNames: ({ commit }, listOfPlayers) => {
    commit("setPlayerNames", listOfPlayers)
  },

  setupInitGame: async ({ commit, getters, dispatch }, payload) => {
    const rounds = Math.max(...payload.map(x => x.round))
    commit("changeRounds", rounds)

    const players = Math.max(...payload.map(x => x.player))
    commit("changePlayers", players)

    const directs = Math.max(...payload.map(x => x.direct))
    commit("changeDirects", directs)

    dispatch("setQuestionData", { questions: payload, rounds, players, directs })
    commit("restartGame")

    const newGame = await postNewGame(getters.getPostMessageBody)
    commit("setObjectId", newGame._id)

    const listOfPlayers = await getPlayers();
    commit("setListOfPlayers", listOfPlayers)
  },

  setButtonContainerCompactFlag: ({ commit }, flag) => {
    commit("setButtonContainerCompactFlag", flag)
  },

  reloadQuestionData: ({ commit, state, dispatch }, payload) => {
    const rounds = Math.max(...payload.map(x => x.round))
    const players = Math.max(...payload.map(x => x.player))
    const directs = Math.max(...payload.map(x => x.direct))

    if (state.numRounds == rounds && state.numPlayers == players && state.numDirects == directs) {
      dispatch("setQuestionData", { questions: payload, rounds, players, directs })
      if (state.resumeGame) {
        commit("toggleResumeGame")
      }
      return { success: true }
    }
    else {
      return { success: false, message: "File format does not match." }
    }
  },

  //When loading the file when game is already on (e.g. reload of page)
  setQuestionData: ({ commit }, { questions, rounds, players, directs }) => {
    const sortedQuestionList = new Array(rounds * players * directs)
    questions.forEach(x => {
      const index = (x.round - 1) * (players * directs) + (x.player - 1) * directs + (x.direct - 1)
      sortedQuestionList[index] = x
    })

    commit("setQuestionData", sortedQuestionList)
  },

  restartGame: ({ commit }) => {
    commit("restartGame")
  },

  setReaderName: ({ commit }, name) => {
    commit("setReaderName", name)
  },

  switchQuestionMode: ({ commit }, mode) => {
    commit("switchQuestionMode", mode)
  },

  setLeagueParams: ({ commit }, payload) => {
    commit("setLeagueParams", payload)
    commit("changePlayers", payload.p)
    let playerNames = []
    for (let i = 0; i < payload.p; i++) {
      playerNames.push(payload[`p${i + 1}`])
    }
    commit("setPlayerNames", playerNames)
  },

  toggleSelfReadValue: ({ commit }) => {
    commit("toggleSelfReadValue");
  },

  toggleFreeDirect: ({ commit }) => {
    commit("toggleFreeDirect");
  },

  togglePeekAnswer: ({ commit }) => {
    commit("togglePeekAnswer")
  },

  showNextQuestion: ({ commit }) => {
    commit("switchQuestionMode", 'Question')
  },

  updateGameResult: ({ state, getters }) => {
    putGame(getters.getPostMessageBody, state.objectId)
  },

  fetchGameData: async ({ commit }, gameId) => {
    //Used to fetch the game data when reloading page during a game
    await getGameByGameId(gameId).then(gameData => {
      commit("loadGameData", gameData);
      commit("calcTotalQuestions")
      commit("calcCurrent")
      commit("setOnDirect", true)
      commit("switchQuestionMode", "Answer")
      commit("setPassingSequence")
    }).catch(err => {
      console.log(err)
    })
  },

  fetchResultData: async ({ commit }, gameId) => {
    //Used to fetch the game data when accessing the results page
    await getGameByGameId(gameId).then(gameData => {
      commit("loadGameData", gameData);
    }).catch(err => {
      console.log(err)
    })
  },

  setInstructions: ({ commit }, instructions) => {
    commit("setInstructions", instructions);
  },

  setGameNotes: ({ commit }, gameNotes) => {
    commit("setGameNotes", gameNotes);
  },

  saveGameResult: async ({ getters }) => {
    await postNewGame(getters.getPostMessageBody);
  },

  updateGameLog: async ({ getters }) => {
    try {
      await postGameLog(getters.getPostGameLogBody)
    } catch (err) {
      console.log("Error in writing game log")
    }
  },

  setLog: ({ commit }, logText) => {
    commit("setLog", logText)
  },

  toggleEmpty: ({ commit }, playerId) => {
    commit("toggleEmpty", playerId)
  },
  setKeyMap: ({ commit }, keyMap) => {
    commit("setKeyMap", keyMap);
  },

  toggleRandomiserMode: ({ commit }) => {
    commit("toggleRandomiserMode")
  },

  toggleResumeGame: ({ commit }) => {
    commit("toggleResumeGame")
  },

  replayGameFromString: ({ commit }) => {
    commit("restartGame", true)
    commit("replayGameFromString")
  },

  moveGamePlayPointer: ({ commit }, value) => {
    commit("moveGamePlayPointer", value)
  }
}